import React, { useEffect, useState } from "react";
import HamburgerMenu from "react-hamburger-menu";
import { theme } from "../../Theme/Theme";
import { styled } from "linaria/react";
import { MobileMenuOverlay } from "./MobileMenuOverlay";
import { css } from "linaria";

export type MobileMenuProps = React.HTMLAttributes<HTMLElement>;

export const MobileMenu: React.FC<MobileMenuProps> = (
  props: MobileMenuProps
) => {
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (mobileMenuIsOpen) {
        document.body.style.height = "100vh";
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.height = "";
        document.body.style.overflowY = "initial";
      }
    }, 230);
  }, [mobileMenuIsOpen]);

  const handleChangeMenuOpenedClicked = () => {
    setMobileMenuIsOpen(!mobileMenuIsOpen);
  };

  return (
    <div className={"relative"}>
      <div style={{}} className="relative">
        <HamburgerMenu
          isOpen={mobileMenuIsOpen}
          color={theme.color.primary}
          menuClicked={handleChangeMenuOpenedClicked}
          width={20}
          height={15}
          strokeWidth={2}
          animationDuration={0.23}
        />
      </div>
      <MobileMenuOverlay
        setOpen={(open) => setMobileMenuIsOpen(open)}
        open={mobileMenuIsOpen}
      />
    </div>
  );
};
